import * as ko from "knockout";
import * as $ from "jquery";
import { ResponseContainer } from "../Models/responsecontainer";
import "qtip2";
import "qtip2/dist/jquery.qtip.min.css";
import { registerDialog } from "dialog-polyfill";
import "dialog-polyfill/dialog-polyfill.css";
import { DialogViewModel, DialogAction } from "./dialogviewmodel";
import { ToastNotification } from "./toastnotification";
import { KnockoutExtensions } from "../KnockoutExtensions/knockoutextensions";
import { LoginResponse } from "../Models/loginresponse";

// Enables Hot Module Replacement.
// tslint:disable-next-line
declare var module: any;
if (module.hot) {
    module.hot.accept();
}

export interface CustomWindow extends Window {
    sessionState: IBaseViewModel;
    // tslint:disable-next-line
    viewModels: Array<IBaseViewModel>;
}
declare let window: CustomWindow;

class BaseViewModel implements IBaseViewModel {

    public static _idCharacters = "_0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz".split("");

    public classname: string;
    public isBusy = ko.observable<boolean>(false);
    public isDirty = ko.observable<boolean>(false);
    public canAccess = ko.observable<boolean>(false);
    public isSessionExpired = ko.observable<boolean>(false);

    public parameters?: string;
    public autoRefresh: boolean = false;

    constructor(paramters?: string) {
        // tslint:disable-next-line
        if (typeof (window as any).showValidationError === "undefined") {
            // tslint:disable-next-line
            (window as any).showValidationError = showValidationError;
        }

        this.parameters = paramters;
    }

    public navigateTo(controller: string, action: string, classTitle: string, viewModelNS: string, parameters: string = null) {
        // Load the view model and view
        var viewModel = (window as CustomWindow).viewModels.find(e => e.classname == `${classTitle}ViewModel`);
        if (viewModel == null) {
            // tslint:disable-next-line
            viewModel = new (window as any)[viewModelNS][`${classTitle}ViewModel`](parameters);
            (window as CustomWindow).viewModels.push(viewModel);
        }

        this.getView(controller, action, HttpAction.GET, viewModel, parameters);

        document.title = `${classTitle}`;
    }

    /**
    * Returns a view (html) to be displayed in the body
    */
    public getView(controller: string, action: string, type: HttpAction, viewModel: IBaseViewModel, parameters: string = null) {
        var self = this;

        $('.maincontent-area').hide();

        var url = `/${action}`;
        if (controller != null) {
            url = `/${controller}/${action}`;
        }
        console.log(url);
        switch (type) {
            case HttpAction.GET:
                {
                    $.get(url)
                        .done(function (response) {
                            if ($(`#${action}Area`).length) {
                                $(`#${action}Area`).show();
                                self.isBusy(false);
                            } else {
                                $('#main-module-area').append(response);
                                ko.applyBindings((viewModel != null ? viewModel : this), $(`#${action}Area`)[0]);
                                self.isBusy(false);
                            }
                            self.upgradeMDL();
                        });
                }
                break;
            case HttpAction.POST:
                {
                    $.post(url, {})
                        .done(function (response) {
                            $("#main-module-area").append(response);
                        });
                }
                break;
        }

        if (this.autoRefresh) {
            viewModel.refresh(parameters);
        }
    }

    public upgradeMDL() {
        if (!(typeof (componentHandler) == 'undefined')) {
            componentHandler.upgradeDom();
        }
    }

    public setCanAccess(canAccess: boolean): void {
        this.canAccess(canAccess);
    }

    public showNotification(notification: ToastNotification, showClose: boolean = false): void {
        if (!showClose)
            notification.show();
        else
            notification.showWithClose();
    }

    public getUniqueId(): string {
        const idlength = 10;
        var getId = () => {
            var idValue = "";
            for (var i = 0; i < idlength; i++) {
                idValue += BaseViewModel._idCharacters[Math.floor(Math.random() * BaseViewModel._idCharacters.length)];
            }
            return idValue;
        };
        var id = getId();
        while ($("#" + id).length > 0) {
            id = getId();
        }
        return id;
    }


    /**
     * Returns a model object from this viewModel, using the knockout mapping options.
     */
    // tslint:disable-next-line
    public toJs(): any {
        return ko.mapping.toJS(this, this.getSaveMappingOptions());
    }

    /**
     * Returns a JSON string from the model object returned by toJs().
     */
    public toJson(): string {
        return JSON.stringify(this.toJs());
    }

    public toPrettyJson(): string {
        return JSON.stringify(this.toJs(), null, 4);
    }

    /**
     * Populates viewmodel properties from the passed model data.
     */
    public fromJs<T>(data: T): void {
        ko.mapping.fromJS(data, this.getLoadMappingOptions(), this);
    }

    public back(): void {
        history.back();
    }

    public redirectTo(action: string): void {
        window.open(action, "_blank");
    }

    // Fetch / post remote data

    /**
     * Fetch json data
     */
    // tslint:disable-next-line
    protected getJsonData<T>(url: string, success: (data: T) => void, error?: JQuery.Ajax.ErrorCallback<any>, complete?: JQuery.Ajax.CompleteCallback<any>) {
        var call = $.getJSON(url, (response: ResponseContainer) => {
            if (success != null) {
                success(response.value as T);
            }
        });
        if (error) {
            call.fail(error);
        }
        if (complete) {
            call.always(complete);
        }
    }

    /**
    * POST data - include Basiv Auth header
    */
    // tslint:disable-next-line
    public postJsonData<T>(url: string, data: T, success?: JQuery.Ajax.SuccessCallback<any>, error?: JQuery.Ajax.ErrorCallback<any>, complete?: JQuery.Ajax.CompleteCallback<any>, authInfo?: string, returnContainer: boolean = false): void {
        this.ajax<T>(url, "POST", data, (authInfo != null ? authInfo : null), (response: ResponseContainer, textStatus, jqXhr) => {
            if (success != null) {
                if (!returnContainer) {
                    success(response.value as T, textStatus, jqXhr);
                } else {
                    success(response as ResponseContainer, textStatus, jqXhr);
                }
            }
        }, error, complete);
    }

    /**
     * PUT data
     */
    // tslint:disable-next-line
    public putJsonData<T>(url: string, data: T, success?: JQuery.Ajax.SuccessCallback<any>, error?: JQuery.Ajax.ErrorCallback<any>, complete?: JQuery.Ajax.CompleteCallback<any>): void {
        this.ajax<T>(url, "PUT", data, null, (response: ResponseContainer, textStatus, jqXhr) => {
            if (success != null) {
                success(response.value as T, textStatus, jqXhr);
            }
        }, error, complete);
    }

    // tslint:disable-next-line
    public deleteData(url: string, success?: JQuery.Ajax.SuccessCallback<any>, error?: JQuery.Ajax.ErrorCallback<any>, complete?: JQuery.Ajax.CompleteCallback<any>): void {
        this.ajax(url, "DELETE", null, null, success, error, complete);
    }

    // tslint:disable-next-line
    private ajax<T>(url: string,
        method: string,
        data: T,
        authHeader?: string,
        // tslint:disable-next-line
        success?: JQuery.Ajax.SuccessCallback<any>,
        // tslint:disable-next-line
        error?: JQuery.Ajax.ErrorCallback<any>,
        // tslint:disable-next-line
        complete?: JQuery.Ajax.CompleteCallback<any>): void {

        var settings: JQueryAjaxSettings = {
            type: method,
            url: url,
            contentType: data != null ? "application/json; charset=utf-8" : null,
            data: data != null ? JSON.stringify(data) : null,
            dataType: data != null ? "json" : null,
            error: error,
            success: success,
            complete: complete
        };

        if (authHeader != null) {
            settings = {
                type: method,
                url: url,
                contentType: data != null ? "application/json; charset=utf-8" : null,
                data: data != null ? JSON.stringify(data) : null,
                dataType: data != null ? "json" : null,
                headers: {
                    "Authorization": authHeader,
                    "Access-Control-Allow-Origin": "*"
                },
                error: error,
                success: success,
                complete: complete
            };
        }

        jQuery.ajax(settings);
    }

    /**
     * Validates the ViewModel and returns true if it is found to be valid. Will show any validation error messages in the bound UI.
     */
    public validate(): string[] {
        var errors = ko.validation.group(this.getValidationObject(), { deep: true });
        if (errors().length > 0) {
            errors.showAllMessages(true);
            return errors();
        } else {
            return null;
        }
    }

    /**
 * Default included and ignored properties for json serialisation.
 */
    protected getPersistenceIncludedProperties(): string[] {
        return [];
    }

    protected getPersistenceIgnoredProperties(): string[] {
        return ["isDirty", "isBusy"];
    }

    public pad(num: number, size: number): string {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    /**
 * Override in derived types to specify mapping configuration
 */
    public getLoadMappingOptions(): KnockoutMappingOptions {
        return {
            include: this.getPersistenceIncludedProperties(),
            ignore: this.getPersistenceIgnoredProperties()
        };
    }

    /**
     * Override in derived types to specify mapping configuration
     */
    public getSaveMappingOptions(): KnockoutMappingOptions {
        return {
            include: this.getPersistenceIncludedProperties(),
            ignore: this.getPersistenceIgnoredProperties()
        };
    }

    /**
     * Returns an object containing all of the properties that should be validated before a save operation
     */
    // tslint:disable-next-line
    public getValidationObject(): any {
        const obj = {};
        $.each(this.getSaveMappingOptions().include,
            (index: number, memberName: string) => {
                // tslint:disable-next-line
                (obj as any)[memberName] = (this as any)[memberName];
            });
        return obj;
    }

    /**
     * Creates a dialog, binds it to the passed DialogViewModel and shows it.
     */
    public showDialog(dialogViewModel: DialogViewModel) {
        // Create the dialog
        const dialogId = `dialog-${dialogViewModel.id}`;
        var $dialog = $("<dialog/>").attr("id", dialogId).attr("data-bind", "mdlDialog");
        $("body").append($dialog);
        // Bind to the viewmodel
        var dialogElement = $dialog.get(0);
        ko.applyBindings(dialogViewModel, dialogElement);
        // Show
        // tslint:disable-next-line
        registerDialog(dialogElement);
        if (dialogViewModel.onBeforeShowModal != null) {
            dialogViewModel.onBeforeShowModal(dialogElement);
        }

        dialogViewModel.upgradeMDL();

        dialogViewModel.refreshButtons();

        // tslint:disable-next-line
        ($dialog.get(0) as any).showModal();
    }

    public init() {
    }

    public refresh(parameters?: string) {

    }

    public writeSetting(key: string, value: string): void {
        if (value == null || undefined == value) {
            window.localStorage.removeItem(key);
        }
        else {
            window.localStorage.setItem(key, value);
        }
    }

    public readSetting(key: string): string {
        return window.localStorage.getItem(key);
    }
}

enum HttpAction {
    GET = 1,
    POST = 2,
    DELETE = 4,
    PUT = 3,
}

interface IBaseViewModel {
    navigateTo(controller: string, action: string, title: string, viewModel: string): void;
    getView(controller: string, action: string, type: HttpAction, viewModel: IBaseViewModel): void;
    setCanAccess(canAccess: boolean): void;
    refresh(parameters?: string): void;
    classname: string;
}

// tslint:disable-next-line
function showValidationError(element: HTMLElement, field: KnockoutObservable<any>) {

    var dialog = $(element).closest("dialog");
    var containerId = (dialog.length > 0) ? "#" + dialog.get(0).id : "main.main-content";
    var adjustY = (dialog.length > 0) ? -20 : 0;
    var adjustX = (dialog.length > 0) ? -4 : 0;

    var tips = $(element).qtip({
        id: "validation-error-tip",
        content: {
            text: field.error()
        },
        position: {
            my: "bottom left",
            at: "top center",
            container: $(containerId),
            viewport: $("main.main-content"),
            adjust: {
                y: adjustY,
                x: adjustX
            }
        },
        show: {
            event: false
        },
        hide: {
            fixed: true,
            event: "unfocus click"
        },
        style: {
            classes: "qtip-light validation-error-tip"
        }
    });

    var api = tips.qtip("api");
    api.toggle(true);
    setTimeout(() => {
        api.destroy(false);
    }, 5000);

}


function initialise() {
    const vm = new BaseViewModel(null);

    vm.navigateTo(null, "login", "Login", "login");
}

export { IBaseViewModel, BaseViewModel, HttpAction, initialise as Initialise };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./Scripts/ViewModels/baseviewmodel.ts